module.exports = __webpack_public_path__ + "static/assets/ddb5a5a7284f669a2c30d41b4ddf063d.png";